(() => {
  const ACTIVITY_COLORS = {
    studio_mouvement: '#BA7150',
    evenement: '#817C56',
    rituel_sauna: '#54625A'
  };

  const WEEKDAY_KEYS = [
    'dimanche',
    'lundi',
    'mardi',
    'mercredi',
    'jeudi',
    'vendredi',
    'samedi'
  ];

  class AwuCalendar {
    constructor(section) {
      this.section = section;
      this.root = section.querySelector('[data-awu-calendar]');
      this.dataNode = section.querySelector('[data-awu-calendar-data]');
      if (!this.root || !this.dataNode) return;

      this.data = this.parseData();
      if (!this.data) return;

      this.data.settings = this.data.settings || {};
      this.translations = this.data.translations || {};
      this.locale = this.data.locale || document.documentElement.lang || 'fr';
      this.defaultEstablishmentId = this.normalizeIdentifier(
        this.data.settings.defaultEstablishmentId || this.root.dataset.defaultEstablishmentId
      );

      this.activities = (this.data.activities || []).map((item) => ({
        ...item,
        id: this.normalizeIdentifier(item.id),
        type: this.normalizeOption(item.type),
        durationMinutes: this.parseDurationMinutes(item.durationMinutes)
      }));

      this.activitiesById = new Map(this.activities.map((item) => [item.id, item]));

      this.establishments = [...(this.data.establishments || [])]
        .map((item) => ({
          ...item,
          id: this.normalizeIdentifier(item.id),
          slug: String(item.slug || '').trim()
        }))
        .sort((a, b) => (Number(a.sortOrder) || 999) - (Number(b.sortOrder) || 999));

      this.occurrences = (this.data.occurrences || []).map((item) => ({
        ...item,
        id: this.normalizeIdentifier(item.id),
        activityId: this.normalizeIdentifier(item.activityId),
        establishmentId: this.normalizeIdentifier(item.establishmentId),
        status: this.normalizeOption(item.status),
        planningMode: this.normalizeOption(item.planningMode),
        frequency: this.normalizeOption(item.frequency),
        repeatDays: Array.isArray(item.repeatDays) ? item.repeatDays.map((day) => this.normalizeDay(day)) : []
      }));

      this.grid = this.root.querySelector('[data-calendar-grid]');
      this.emptyState = this.root.querySelector('[data-calendar-empty]');
      this.currentPeriodNode = this.root.querySelector('[data-calendar-current-period]');
      this.weekdaysNode = this.root.querySelector('[data-calendar-weekdays]');
      this.mobileDaysNode = this.root.querySelector('[data-calendar-mobile-days]');
      this.datePicker = this.root.querySelector('[data-calendar-date-picker]');
      this.dateTrigger = this.root.querySelector('[data-calendar-date-trigger]');
      this.prevButton = this.root.querySelector('[data-calendar-prev]');
      this.nextButton = this.root.querySelector('[data-calendar-next]');
      this.establishmentTabs = Array.from(this.root.querySelectorAll('[data-establishment-tab]'));
      this.typeFilters = Array.from(this.root.querySelectorAll('[data-type-filter]'));
      this.establishmentButtonActiveClass = this.root.dataset.establishmentButtonActiveClass || 'button--primary';
      this.establishmentButtonInactiveClass = this.root.dataset.establishmentButtonInactiveClass || 'button--secondary';

      this.hourStart = this.timeStringToMinutes(this.data.settings.hourStart || '08:00');
      this.hourEnd = this.timeStringToMinutes(this.data.settings.hourEnd || '22:00');
      this.totalMinutes = Math.max(60, this.hourEnd - this.hourStart);

      this.today = this.normalizeDate(new Date());
      this.selectedDate = this.today;
      this.activeDate = this.today;
      this.activeTypes = new Set(this.typeFilters.map((input) => this.normalizeOption(input.value)));
      this.isMobile = window.matchMedia('(max-width: 749px)').matches;
      this.activeEstablishmentId = this.getInitialEstablishmentId();

      this.modal = this.buildModal();
      this.bindEvents();
      this.render();

      console.log('AWU Calendar debug', {
        locale: this.locale,
        translations: this.translations,
        defaultEstablishmentId: this.defaultEstablishmentId,
        activeEstablishmentId: this.activeEstablishmentId,
        establishments: this.establishments,
        occurrences: this.occurrences,
        activities: this.activities
      });
    }

    parseData() {
      try {
        return JSON.parse(this.dataNode.textContent);
      } catch (error) {
        console.error('AWU Calendar: invalid JSON payload.', error);
        return null;
      }
    }

    t(key, fallback = '') {
      return this.translations[key] || fallback;
    }

    capitalize(value) {
      const stringValue = String(value || '');
      return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
    }

    formatWeekdayShort(date) {
      return new Intl.DateTimeFormat(this.locale, {
        weekday: 'short'
      }).format(date);
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.shiftPeriod(-1));
        this.prevButton.addEventListener('mouseenter', () => {
          this.applyWeekNavHoverStyles(this.prevButton);
        });
        this.prevButton.addEventListener('mouseleave', () => {
          this.clearWeekNavHoverStyles(this.prevButton);
        });
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.shiftPeriod(1));
        this.nextButton.addEventListener('mouseenter', () => {
          this.applyWeekNavHoverStyles(this.nextButton);
        });
        this.nextButton.addEventListener('mouseleave', () => {
          this.clearWeekNavHoverStyles(this.nextButton);
        });
      }

      if (this.datePicker) {
        this.datePicker.addEventListener('change', (event) => {
          if (!event.target.value) return;
          const nextDate = this.parseIsoDate(event.target.value);
          if (!nextDate) return;
          this.activeDate = nextDate;
          this.selectedDate = nextDate;
          this.render();
        });
      }

      if (this.dateTrigger && this.datePicker) {
  this.dateTrigger.addEventListener('click', () => {
    if (typeof this.datePicker.showPicker === 'function') {
      this.datePicker.showPicker();
      return;
    }

    this.datePicker.focus();
    this.datePicker.click();
  });
}

      this.establishmentTabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const nextEstablishmentId = this.getTabEstablishmentId(tab);
          if (!nextEstablishmentId) return;
          this.activeEstablishmentId = nextEstablishmentId;
          this.render();
        });

        tab.addEventListener('mouseenter', () => {
          const isActive = this.getTabEstablishmentId(tab) === this.activeEstablishmentId;
          if (isActive) return;
          this.applyEstablishmentHoverStyles(tab);
        });

        tab.addEventListener('mouseleave', () => {
          const isActive = this.getTabEstablishmentId(tab) === this.activeEstablishmentId;
          if (isActive) return;
          this.clearEstablishmentHoverStyles(tab);
        });
      });

      this.typeFilters.forEach((input) => {
        input.addEventListener('change', () => {
          const checked = this.typeFilters
            .filter((item) => item.checked)
            .map((item) => this.normalizeOption(item.value));
          this.activeTypes = new Set(checked);
          this.render();
        });
      });

      if (window.matchMedia) {
        const media = window.matchMedia('(max-width: 749px)');
        const onChange = (event) => {
          this.isMobile = event.matches;
          this.render();
        };

        if (media.addEventListener) {
          media.addEventListener('change', onChange);
        } else if (media.addListener) {
          media.addListener(onChange);
        }
      }

      let resizeFrame = null;
      window.addEventListener('resize', () => {
        if (resizeFrame) cancelAnimationFrame(resizeFrame);
        resizeFrame = requestAnimationFrame(() => {
          this.render();
        });
      });
    }

    getInitialEstablishmentId() {
      const forcedSlug = String(this.data.settings.forceEstablishmentSlug || '').trim();
      if (forcedSlug) {
        const forced = this.establishments.find((item) => item.slug === forcedSlug);
        if (forced && forced.id) return forced.id;

        const forcedTab = this.establishmentTabs.find((tab) => tab.dataset.establishmentSlug === forcedSlug);
        if (forcedTab) return this.getTabEstablishmentId(forcedTab);
      }

      if (this.defaultEstablishmentId) {
        return this.defaultEstablishmentId;
      }

      if (this.establishments.length && this.establishments[0].id) {
        return this.establishments[0].id;
      }

      if (this.establishmentTabs.length) {
        return this.getTabEstablishmentId(this.establishmentTabs[0]);
      }

      return null;
    }

    getTabEstablishmentId(tab) {
      if (!tab) return null;
      return this.normalizeIdentifier(tab.dataset.establishmentId);
    }

    shiftPeriod(direction) {
      if (this.isMobile) {
        this.activeDate = this.addDays(this.activeDate, direction);
      } else {
        this.activeDate = this.addDays(this.activeDate, direction * 7);
      }
      this.selectedDate = this.activeDate;
      this.render();
    }

    render() {
      this.syncUiState();
      const visibleDates = this.isMobile ? [this.activeDate] : this.getWeekDays(this.activeDate);
      const generatedOccurrences = this.generateVisibleOccurrences(visibleDates);
      const filteredOccurrences = generatedOccurrences.filter((item) => this.activeTypes.has(item.type));

      this.renderHeader(visibleDates);
      this.renderWeekdays(visibleDates);
      this.renderGrid(visibleDates, filteredOccurrences);
    }

    syncUiState() {
      if (!this.activeEstablishmentId) {
        this.activeEstablishmentId = this.getInitialEstablishmentId();
      }

      this.establishmentTabs.forEach((tab) => {
        const tabEstablishmentId = this.getTabEstablishmentId(tab);
        const isActive = tabEstablishmentId === this.activeEstablishmentId;
        const label = tab.querySelector('span');

        tab.classList.toggle('is-active', isActive);
        tab.classList.toggle(this.establishmentButtonActiveClass, isActive);
        tab.classList.toggle(this.establishmentButtonInactiveClass, !isActive);
        tab.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        tab.dataset.establishmentActive = isActive ? 'true' : 'false';

        if (isActive) {
          tab.setAttribute('aria-current', 'true');
          tab.style.setProperty('background', '#FED996', 'important');
          tab.style.setProperty('background-color', '#FED996', 'important');
          tab.style.setProperty('border', '1px solid #FED996', 'important');
          tab.style.setProperty('border-color', '#FED996', 'important');
          tab.style.setProperty('box-shadow', 'none', 'important');
          tab.style.setProperty('outline', '0', 'important');
          tab.style.setProperty('color', 'rgb(var(--color-foreground))', 'important');
          tab.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-foreground))', 'important');
          tab.style.setProperty('background-image', 'none', 'important');
          tab.style.setProperty('filter', 'none', 'important');
          if (label) {
            label.style.setProperty('color', 'rgb(var(--color-foreground))', 'important');
            label.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-foreground))', 'important');
          }
        } else {
          tab.removeAttribute('aria-current');
          tab.style.setProperty('background', 'transparent', 'important');
          tab.style.setProperty('background-color', 'transparent', 'important');
          tab.style.setProperty('border', '1px solid rgb(var(--color-foreground))', 'important');
          tab.style.setProperty('border-color', 'rgb(var(--color-foreground))', 'important');
          tab.style.setProperty('box-shadow', 'none', 'important');
          tab.style.setProperty('outline', '0', 'important');
          tab.style.setProperty('color', 'rgb(var(--color-button-text))', 'important');
          tab.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-button-text))', 'important');
          tab.style.setProperty('background-image', 'none', 'important');
          tab.style.setProperty('filter', 'none', 'important');
          if (label) {
            label.style.setProperty('color', 'rgb(var(--color-button-text))', 'important');
            label.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-button-text))', 'important');
          }
        }
      });

      if (this.datePicker) {
        this.datePicker.value = this.toIsoDate(this.activeDate);
      }
    }

    applyEstablishmentHoverStyles(tab) {
      const label = tab.querySelector('span');
      tab.style.setProperty('background', '#FED996', 'important');
      tab.style.setProperty('background-color', '#FED996', 'important');
      tab.style.setProperty('border', '1px solid #FED996', 'important');
      tab.style.setProperty('border-color', '#FED996', 'important');
      tab.style.setProperty('color', 'rgb(var(--color-foreground))', 'important');
      tab.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-foreground))', 'important');
      if (label) {
        label.style.setProperty('color', 'rgb(var(--color-foreground))', 'important');
        label.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-foreground))', 'important');
      }
    }

    clearEstablishmentHoverStyles(tab) {
      const label = tab.querySelector('span');
      tab.style.setProperty('background', 'transparent', 'important');
      tab.style.setProperty('background-color', 'transparent', 'important');
      tab.style.setProperty('border', '1px solid rgb(var(--color-foreground))', 'important');
      tab.style.setProperty('border-color', 'rgb(var(--color-foreground))', 'important');
      tab.style.setProperty('color', 'rgb(var(--color-button-text))', 'important');
      tab.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-button-text))', 'important');
      if (label) {
        label.style.setProperty('color', 'rgb(var(--color-button-text))', 'important');
        label.style.setProperty('-webkit-text-fill-color', 'rgb(var(--color-button-text))', 'important');
      }
    }

    applyWeekNavHoverStyles(button) {
      button.style.setProperty('background', '#FED996', 'important');
      button.style.setProperty('background-color', '#FED996', 'important');
      button.style.setProperty('border-color', '#FED996', 'important');
    }

    clearWeekNavHoverStyles(button) {
      button.style.removeProperty('background');
      button.style.removeProperty('background-color');
      button.style.removeProperty('border-color');
    }

    renderHeader(visibleDates) {
      if (!this.currentPeriodNode) return;

      if (this.isMobile) {
        this.currentPeriodNode.textContent = this.formatLongDate(this.activeDate);
        return;
      }

      const weekStart = visibleDates[0];
      const weekEnd = visibleDates[visibleDates.length - 1];
      this.currentPeriodNode.textContent = `${this.formatDayMonth(weekStart)} – ${this.formatDayMonthYear(weekEnd)}`;
    }

    renderWeekdays(visibleDates) {
      if (this.weekdaysNode) {
        this.weekdaysNode.innerHTML = '';
        if (!this.isMobile) {
          visibleDates.forEach((date) => {
            const item = document.createElement('div');
            item.className = 'awu-calendar__weekday';
            item.innerHTML = `<span>${this.capitalize(this.formatWeekdayShort(date))}</span><strong>${date.getDate()}</strong>`;
            this.weekdaysNode.appendChild(item);
          });
        }
      }

      if (this.mobileDaysNode) {
        this.mobileDaysNode.innerHTML = '';
        if (this.isMobile) {
          this.getWeekDays(this.activeDate).forEach((date) => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'awu-calendar__mobile-day';
            if (this.isSameDate(date, this.activeDate)) {
              button.classList.add('is-active');
            }
            button.innerHTML = `<span>${this.capitalize(this.formatWeekdayShort(date))}</span><strong>${date.getDate()}</strong>`;
            button.addEventListener('click', () => {
              this.activeDate = date;
              this.selectedDate = date;
              this.render();
            });
            this.mobileDaysNode.appendChild(button);
          });
        }
      }
    }

    renderGrid(visibleDates, occurrences) {
      if (!this.grid) return;

      this.grid.innerHTML = '';

      const body = document.createElement('div');
      body.className = 'awu-calendar__grid-body';
      body.style.setProperty('--awu-calendar-columns', String(visibleDates.length));

      const timeColumn = this.createTimeColumn();
      body.appendChild(timeColumn);

      const groupedByDate = this.groupByDate(occurrences);

      visibleDates.forEach((date) => {
        const dayColumn = document.createElement('div');
        dayColumn.className = 'awu-calendar__day-column';
        dayColumn.dataset.date = this.toIsoDate(date);

        const backgrounds = this.createHourBackgrounds();
        dayColumn.appendChild(backgrounds);

        const dayItems = groupedByDate.get(this.toIsoDate(date)) || [];
        const laidOutItems = this.computeOverlapLayout(dayItems);
        laidOutItems.forEach((item) => {
          dayColumn.appendChild(this.createEventCard(item));
        });

        body.appendChild(dayColumn);
      });

      const hasResults = occurrences.length > 0;
      if (this.emptyState) {
        this.emptyState.hidden = hasResults;
      }

      this.grid.appendChild(body);
      if (this.emptyState) {
        this.grid.appendChild(this.emptyState);
      }

      requestAnimationFrame(() => {
        this.syncDesktopColumnWidths(body);
        this.syncEventPositions(body);
      });
    }

    createTimeColumn() {
      const column = document.createElement('div');
      column.className = 'awu-calendar__time-column';

      for (let minutes = this.hourStart; minutes <= this.hourEnd; minutes += 60) {
        const label = document.createElement('div');
        label.className = 'awu-calendar__time-slot';
        label.textContent = this.minutesToTimeLabel(minutes);
        column.appendChild(label);
      }

      return column;
    }

    createHourBackgrounds() {
      const background = document.createElement('div');
      background.className = 'awu-calendar__day-background';

      for (let minutes = this.hourStart; minutes < this.hourEnd; minutes += 60) {
        const row = document.createElement('div');
        row.className = 'awu-calendar__hour-row';
        background.appendChild(row);
      }

      return background;
    }

    createEventCard(item) {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'awu-calendar__event';
      card.dataset.status = item.status;
      card.dataset.startMinutes = String(item.startMinutes);
      card.dataset.endMinutes = String(item.endMinutes);
      card.style.setProperty('--awu-event-top', `${item.topPercent}%`);
      card.style.setProperty('--awu-event-height', `${item.heightPercent}%`);
      card.style.setProperty('--awu-event-width', `${item.widthPercent}%`);
      card.style.setProperty('--awu-event-left', `${item.leftPercent}%`);
      card.style.setProperty('--awu-event-color', ACTIVITY_COLORS[item.type] || '#777777');

      card.innerHTML = `
        <span class="awu-calendar__event-time">${this.minutesToTimeLabel(item.startMinutes)}</span>
        <strong class="awu-calendar__event-title">${this.escapeHtml(item.title)}</strong>
      `;

      card.addEventListener('click', () => this.openModal(item));
      return card;
    }

    openModal(item) {
      if (!this.modal) return;

      const imageMarkup = item.image
        ? `<div class="awu-calendar-modal__image-wrap"><img src="${this.escapeHtml(item.image)}" alt="${this.escapeHtml(item.title)}"></div>`
        : '';

      const teacherMarkup = item.teacher
        ? `<p class="awu-calendar-modal__meta"><strong>${this.escapeHtml(this.t('host', 'Animateur'))} :</strong> ${this.escapeHtml(item.teacher)}</p>`
        : '';

      const durationMarkup = item.durationMinutes
        ? `<p class="awu-calendar-modal__meta"><strong>${this.escapeHtml(this.t('duration', 'Durée'))} :</strong> ${item.durationMinutes} min</p>`
        : '';

      this.modal.content.innerHTML = `
        ${imageMarkup}
        <div class="awu-calendar-modal__body">
          <h3 class="awu-calendar-modal__title">${this.escapeHtml(item.title)}</h3>
          <p class="awu-calendar-modal__meta"><strong>${this.escapeHtml(this.t('time', 'Heure'))} :</strong> ${this.minutesToTimeLabel(item.startMinutes)} – ${this.minutesToTimeLabel(item.endMinutes)}</p>
          ${teacherMarkup}
          ${durationMarkup}
          ${item.description ? `<div class="awu-calendar-modal__description">${item.description}</div>` : ''}
        </div>
      `;

      this.modal.root.hidden = false;
      document.documentElement.classList.add('awu-calendar-modal-open');
      this.modal.closeButton.focus();
    }

    closeModal() {
      if (!this.modal) return;
      this.modal.root.hidden = true;
      document.documentElement.classList.remove('awu-calendar-modal-open');
    }

    buildModal() {
      const modal = document.createElement('div');
      modal.className = 'awu-calendar-modal';
      modal.hidden = true;
      modal.innerHTML = `
        <div class="awu-calendar-modal__overlay" data-modal-close></div>
        <div class="awu-calendar-modal__dialog" role="dialog" aria-modal="true" aria-label="${this.escapeHtml(this.t('modalTitle', 'Détails de l’activité'))}">
          <button type="button" class="awu-calendar-modal__close" aria-label="${this.escapeHtml(this.t('close', 'Fermer'))}" data-modal-close>×</button>
          <div class="awu-calendar-modal__content"></div>
        </div>
      `;

      this.section.appendChild(modal);

      const closeElements = modal.querySelectorAll('[data-modal-close]');
      closeElements.forEach((element) => {
        element.addEventListener('click', () => this.closeModal());
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !modal.hidden) {
          this.closeModal();
        }
      });

      return {
        root: modal,
        content: modal.querySelector('.awu-calendar-modal__content'),
        closeButton: modal.querySelector('.awu-calendar-modal__close')
      };
    }

    generateVisibleOccurrences(visibleDates) {
      if (!this.activeEstablishmentId) return [];

      const visibleStart = visibleDates[0];
      const visibleEnd = visibleDates[visibleDates.length - 1];
      const results = [];

      this.occurrences.forEach((occurrence) => {
        if (occurrence.establishmentId !== this.activeEstablishmentId) return;

        const activity = this.activitiesById.get(occurrence.activityId);
        if (!activity) return;

        if (occurrence.planningMode === 'ponctuel') {
          const date = this.parseIsoDate(occurrence.startDate);
          if (!date || !this.isDateInRange(date, visibleStart, visibleEnd)) return;
          const item = this.buildRenderedOccurrence(occurrence, activity, date);
          if (item) results.push(item);
          return;
        }

        if (occurrence.planningMode === 'recurrent' || occurrence.planningMode === 'recurrente') {
          const recurringDates = this.generateRecurringDates(occurrence, visibleStart, visibleEnd);
          recurringDates.forEach((date) => {
            const item = this.buildRenderedOccurrence(occurrence, activity, date);
            if (item) results.push(item);
          });
        }
      });

      return results.sort((a, b) => a.dateTimeStart - b.dateTimeStart);
    }

    buildRenderedOccurrence(occurrence, activity, date) {
      const startMinutes = this.timeStringToMinutes(occurrence.startTime || '00:00');
      if (startMinutes == null) return null;

      const durationMinutes = Math.max(this.parseDurationMinutes(activity.durationMinutes), 10);
      const endMinutes = startMinutes + durationMinutes;
      const dateTimeStart = this.combineDateAndMinutes(date, startMinutes);
      const dateTimeEnd = this.combineDateAndMinutes(date, endMinutes);

      return {
        id: `${occurrence.id}-${this.toIsoDate(date)}`,
        occurrenceId: occurrence.id,
        date,
        dateKey: this.toIsoDate(date),
        dateTimeStart,
        dateTimeEnd,
        startMinutes,
        endMinutes,
        durationMinutes,
        title: activity.title || '',
        type: activity.type || '',
        description: activity.description || '',
        image: activity.image || null,
        teacher: occurrence.teacher || '',
        status: occurrence.status || 'actif'
      };
    }

    generateRecurringDates(occurrence, visibleStart, visibleEnd) {
      const startDate = this.parseIsoDate(occurrence.startDate);
      if (!startDate) return [];

      const endDate = occurrence.endDate ? this.parseIsoDate(occurrence.endDate) : visibleEnd;
      const rangeStart = startDate > visibleStart ? startDate : visibleStart;
      const rangeEnd = endDate && endDate < visibleEnd ? endDate : visibleEnd;

      if (rangeStart > rangeEnd) return [];

      if (occurrence.frequency === 'hebdomadaire') {
        return this.generateWeeklyDates(occurrence, rangeStart, rangeEnd, startDate);
      }

      if (occurrence.frequency === 'mensuel') {
        return this.generateMonthlyDates(occurrence, rangeStart, rangeEnd, startDate);
      }

      return [];
    }

    generateWeeklyDates(occurrence, rangeStart, rangeEnd, seriesStart) {
      const repeatDays = Array.isArray(occurrence.repeatDays) ? occurrence.repeatDays : [];
      if (!repeatDays.length) {
        const fallbackDate = this.normalizeDate(seriesStart);
        return this.isDateInRange(fallbackDate, rangeStart, rangeEnd) ? [fallbackDate] : [];
      }

      const dayIndexes = repeatDays.map((day) => WEEKDAY_KEYS.indexOf(this.normalizeDay(day))).filter((index) => index >= 0);
      const dates = [];
      let cursor = new Date(rangeStart);

      while (cursor <= rangeEnd) {
        if (dayIndexes.includes(cursor.getDay()) && cursor >= seriesStart) {
          dates.push(new Date(cursor));
        }
        cursor = this.addDays(cursor, 1);
      }

      return dates;
    }

    generateMonthlyDates(occurrence, rangeStart, rangeEnd, seriesStart) {
      const dayOfMonth = Number(occurrence.dayOfMonth || seriesStart.getDate());
      const dates = [];
      let cursor = new Date(rangeStart.getFullYear(), rangeStart.getMonth(), 1);

      while (cursor <= rangeEnd) {
        const lastDay = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 0).getDate();
        const safeDay = Math.min(dayOfMonth, lastDay);
        const candidate = new Date(cursor.getFullYear(), cursor.getMonth(), safeDay);

        if (candidate >= rangeStart && candidate <= rangeEnd && candidate >= seriesStart) {
          dates.push(candidate);
        }

        cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1);
      }

      return dates;
    }

    groupByDate(items) {
      const map = new Map();
      items.forEach((item) => {
        const key = item.dateKey;
        if (!map.has(key)) {
          map.set(key, []);
        }
        map.get(key).push(item);
      });
      return map;
    }

computeOverlapLayout(items) {
  const sorted = [...items].sort(
    (a, b) => a.startMinutes - b.startMinutes || a.endMinutes - b.endMinutes
  );

  const groups = [];
  let currentGroup = [];
  let currentGroupEnd = -Infinity;

  sorted.forEach((item) => {
    if (!currentGroup.length) {
      currentGroup = [item];
      currentGroupEnd = item.endMinutes;
      return;
    }

    if (item.startMinutes < currentGroupEnd) {
      currentGroup.push(item);
      currentGroupEnd = Math.max(currentGroupEnd, item.endMinutes);
    } else {
      groups.push(currentGroup);
      currentGroup = [item];
      currentGroupEnd = item.endMinutes;
    }
  });

  if (currentGroup.length) {
    groups.push(currentGroup);
  }

  const laidOutItems = [];

  groups.forEach((group) => {
    const columns = [];
    const columnItems = [];

    group.forEach((item) => {
      let assignedColumn = 0;

      while (
        columns[assignedColumn] != null &&
        columns[assignedColumn] > item.startMinutes
      ) {
        assignedColumn += 1;
      }

      columns[assignedColumn] = item.endMinutes;
      item.columnIndex = assignedColumn;

      if (!columnItems[assignedColumn]) {
        columnItems[assignedColumn] = [];
      }
      columnItems[assignedColumn].push(item);
    });

    const totalColumns = columns.length;

    group.forEach((item) => {
      let colSpan = 1;

      for (let nextColumn = item.columnIndex + 1; nextColumn < totalColumns; nextColumn += 1) {
        const hasConflictInNextColumn = (columnItems[nextColumn] || []).some((candidate) =>
          this.overlaps(item, candidate)
        );

        if (hasConflictInNextColumn) {
          break;
        }

        colSpan += 1;
      }

      const eventDuration = Math.max(item.endMinutes - item.startMinutes, 10);

      item.widthPercent = (colSpan / totalColumns) * 100;
      item.leftPercent = (item.columnIndex / totalColumns) * 100;
      item.topPercent = ((item.startMinutes - this.hourStart) / this.totalMinutes) * 100;
      item.heightPercent = (eventDuration / this.totalMinutes) * 100;

      laidOutItems.push(item);
    });
  });

  return laidOutItems;
}

    syncDesktopColumnWidths(body) {
      if (this.isMobile || !this.weekdaysNode || !body) return;

      const bodyChildren = Array.from(body.children);
      if (!bodyChildren.length) return;

      const widths = bodyChildren.map((child) => `${child.getBoundingClientRect().width}px`);
      if (widths.length) {
        this.weekdaysNode.style.gridTemplateColumns = widths.join(' ');
      }
    }

    syncEventPositions(body) {
      if (!body) return;

      const dayColumns = Array.from(body.querySelectorAll('.awu-calendar__day-column'));
      dayColumns.forEach((dayColumn) => {
        const rows = Array.from(dayColumn.querySelectorAll('.awu-calendar__hour-row'));
        if (!rows.length) return;

        const firstRowRect = rows[0].getBoundingClientRect();
        const rowHeight = firstRowRect.height;
        if (!rowHeight) return;

        const cards = Array.from(dayColumn.querySelectorAll('.awu-calendar__event'));

        cards.forEach((card) => {
          const startMinutes = Number(card.dataset.startMinutes || 0);
          const endMinutes = Number(card.dataset.endMinutes || 0);
          const durationMinutes = Math.max(endMinutes - startMinutes, 10);
          const minutesFromStart = Math.max(startMinutes - this.hourStart, 0);
          const hourIndex = Math.floor(minutesFromStart / 60);
          const minuteOffset = minutesFromStart % 60;
          const topPx = (hourIndex * rowHeight) + ((minuteOffset / 60) * rowHeight);
          const heightPx = (durationMinutes / 60) * rowHeight;

          card.style.top = `${topPx}px`;
          card.style.height = `${heightPx}px`;
        });
      });
    }

    overlaps(a, b) {
      return a.startMinutes < b.endMinutes && b.startMinutes < a.endMinutes;
    }

    getWeekDays(date) {
      const start = this.getMonday(date);
      return Array.from({ length: 7 }, (_, index) => this.addDays(start, index));
    }

    getMonday(date) {
      const normalized = this.normalizeDate(date);
      const day = normalized.getDay();
      const diff = day === 0 ? -6 : 1 - day;
      return this.addDays(normalized, diff);
    }

    isDateInRange(date, start, end) {
      const normalized = this.normalizeDate(date);
      return normalized >= this.normalizeDate(start) && normalized <= this.normalizeDate(end);
    }

    isSameDate(a, b) {
      return this.toIsoDate(a) === this.toIsoDate(b);
    }

    normalizeDate(date) {
      return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    }

    parseIsoDate(value) {
      if (!value) return null;
      const parts = String(value).split('-').map(Number);
      if (parts.length !== 3 || parts.some(Number.isNaN)) return null;
      return new Date(parts[0], parts[1] - 1, parts[2]);
    }

    toIsoDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    }

    addDays(date, amount) {
      const next = new Date(date);
      next.setDate(next.getDate() + amount);
      return this.normalizeDate(next);
    }

    combineDateAndMinutes(date, minutes) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours, mins, 0, 0);
    }

    timeStringToMinutes(value) {
      const match = String(value || '').match(/^(\d{2}):(\d{2})$/);
      if (!match) return null;
      return Number(match[1]) * 60 + Number(match[2]);
    }

    minutesToTimeLabel(totalMinutes) {
      const normalized = Math.max(0, totalMinutes);
      const hours = Math.floor(normalized / 60);
      const minutes = normalized % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
    }

    formatLongDate(date) {
      return this.capitalize(
        new Intl.DateTimeFormat(this.locale, {
          weekday: 'long',
          day: 'numeric',
          month: 'long',
          year: 'numeric'
        }).format(date)
      );
    }

    formatDayMonth(date) {
      return new Intl.DateTimeFormat(this.locale, {
        day: 'numeric',
        month: 'long'
      }).format(date);
    }

    formatDayMonthYear(date) {
      return new Intl.DateTimeFormat(this.locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      }).format(date);
    }

    normalizeDay(value) {
      return this.normalizeOption(value);
    }

    normalizeOption(value) {
      return String(value || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]+/g, '_')
        .replace(/^_+|_+$/g, '');
    }

    normalizeIdentifier(value) {
      if (value == null) return null;
      const normalized = String(value).trim();
      return normalized === '' ? null : normalized;
    }

    parseDurationMinutes(value) {
      if (typeof value === 'number' && Number.isFinite(value)) {
        return value;
      }

      const normalized = String(value || '').trim();
      if (!normalized) return 0;

      const match = normalized.match(/(\d+)/);
      if (!match) return 0;

      return Number(match[1]) || 0;
    }

    escapeHtml(value) {
      return String(value == null ? '' : value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }
  }

  const init = () => {
    const sections = document.querySelectorAll('.awu-calendar-section');
    sections.forEach((section) => {
      if (section.dataset.awuCalendarInitialized === 'true') return;
      section.dataset.awuCalendarInitialized = 'true';
      new AwuCalendar(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
